export default __webpack_public_path__ + "static/media/matlab-icon.9e090734.svg";